var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppStoreDarkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Play_store_-_Color_",
    "data-name": "Play store - Color ",
    transform: "translate(-863 -620)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "apple-app-store_1",
    transform: "translate(863 601.376)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M.7,28.949a.7.7,0,0,1,0-1.4H8.05c.7,0,1.4,1.4,1.05,1.4Zm9.8,0a.7.7,0,1,1,0-1.4h2.8a.7.7,0,1,1,0,1.4ZM7.443,19.5a.7.7,0,0,1,1.214.7L3.823,28.6a.7.7,0,0,1-1.214-.7ZM1.4,30c.35-.7,2.45-1.4,1.75-.194-.123.213-.506.861-1.143,1.944a.7.7,0,1,1-1.214-.7Zm3.593-9.8a.7.7,0,0,1,1.214-.7l1.22,2.119a.7.7,0,1,1-1.211.7ZM7.7,25.1c-.629-1.05,0-3.15.5-2.1l4.657,8.053a.7.7,0,1,1-1.214.7Z",
    fill: "#1d81f3"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M0,0H14V14H0Z",
    transform: "translate(863 620)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreDarkIcon);
export default __webpack_public_path__ + "static/media/app-store-dark-icon.90fa18f0980850347d31895615a30801.svg";
export { ForwardRef as ReactComponent };